<div
  class="layout-sidebar"
  [ngClass]="menuClass()"
  id="menu-wrap"
  (mouseover)="showMenu()"
  (mouseleave)="hideMenu()"
>
  <div class="logo-wrap">
    <a class="logo" [ngClass]="{ hide: menuClosed }">
      <img alt="logo" [src]="logoUrl" />
    </a>
    <div
      class="layout-toggle-sidebar"
      (click)="onMenuButtonClick($event)"
      [ngClass]="getClass()"
    ></div>
  </div>
  <div class="layout-menu">
    <p-panelMenu [model]="items" [style]="{ width: '250px' }"></p-panelMenu>
  </div>
</div>
<app-base-loader [loader]="loading"></app-base-loader>
